import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { MarketProductItem } from '~/api/model';

// Response 타입 (Zod Model 재사용 — OAISchema 금지, api-typegen §0)
type CampaignProductsResponse = MarketProductItem[];

export type CampaignProductsParams = {
  vendorId?: number;
  displayCategoryIds?: number[];
};

export interface CampaignDataSource {
  getTodayCampaignProducts(
    params: CampaignProductsParams,
  ): Promise<CampaignProductsResponse>;
}

export class CampaignDataSourceImpl implements CampaignDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getTodayCampaignProducts(params: CampaignProductsParams) {
    return this.client.request<CampaignProductsResponse>({
      url: '/api/market-place/v1/campaigns/products',
      method: 'get',
      params: { ...params },
    });
  }
}

export const campaignDataSource = new CampaignDataSourceImpl();
